// this adds some missing features to the codeinput component
// should be better implemented here: https://www.npmjs.com/package/vue-verification-code-input

const codeInputWorkarounds = {
  methods: {
    focusCodeInput() {
      this.$refs.codeinput.$refs.input_0[0].focus();
    },
    clearCodeInput() {
      this.$refs.codeinput.values = Array(this.$refs.codeinput.fields).fill('');
      this.$refs.codeinput.triggerChange();
    },
    setupPasteCatcher() {
      var vm = this;
      this.$refs.codeinput.$refs.input_0[0].addEventListener(
        'paste',
        (event) => {
          // gotta love JS DataTransferItem - Yes, getAsString() wants a callback
          event.clipboardData.items[0].getAsString((s) => {
            vm.$refs.codeinput.values = s.split('');
            vm.$refs.codeinput.triggerChange();
          });
          event.preventDefault();
        }
      );
    },
  },
  computed: {
    codeInputFieldWidth() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 45;
      } else {
        return 58;
      }
    },
  },
};

export default codeInputWorkarounds;



// WEBPACK FOOTER //
// ./src/mixins/codeInputWorkarounds.js